var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('TelephonyRedirectShell',{attrs:{"loading":_vm.loading,"show-main-content":_vm.showDisambiguation,"not-found-context":_vm.notFoundContext,"error-message":_vm.errorMessage}},[_c('TelephonyDisambiguation',{attrs:{"matches":_vm.matches,"phone-display":_vm.callerPhoneDisplay},on:{"select":_vm.onSelectMatch}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }